export const auth = {
  signin: {
    title: "One of Our Valued Members",
    subTitle:
      "Thank you for being part of our community. Your presence enriches our shared experiences. Let's continue this journey together!",
  },
  signup: {
    title: "New to our community\u00A0?",
    subTitle:
      "Discover a world of possibilities! Join us and explore a vibrant community where ideas flourish and connections thrive.",
  },
  awsAuth: {
    subTitle: "Let's connect your account with aws",
  },
};
